import type Guid from "@/app/types/common/guid";
import { MenuItem } from "@/app/ui/navigation/types";
import type { Location } from "vue-router";
import { EnumFeatureFlag } from "@/app/services/generated/enums/enumFeatureFlag.generated";
import tenantStore from "@/store/modules/tenantStore";
import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { hasPermissionsUsingUserStore } from "@/components/pages/administration/user_roles/UserAccessHandler";

export const containerTrackingMenu = {
  root: "navigation_container_tracking_group",
  list: "tracked_containers",
  listLocation: (): Location => ({ name: containerTrackingMenu.list }),
  v6List: "tracked_containers_v6",
  v6ListLocation: (): Location => ({ name: containerTrackingMenu.v6List }),
  create: "containers_create",
  v6Create: "migrate_containers",
  v6CreateLocation: (): Location => ({ name: containerTrackingMenu.v6Create }),
  view: "containers_edit",
  viewContainer: (id: Guid): Location => ({
    name: containerTrackingMenu.view,
    params: {
      id: id.toString(),
    },
  }),
  kegstarList: "tracked_kegstar_containers",
  viewKegstarListLocation: (): Location => ({
    name: containerTrackingMenu.kegstarList,
  }),
  containerTreatmentReport: "container_treatment_report",
};

export const buildContainerTrackingMenuItems = () => [
  MenuItem.forBranch({
    name: containerTrackingMenu.root,
    icon: "gps_fixed",
    visible: () =>
      hasPermissionsUsingUserStore([
        EnumUserPermission.menuContainerTrackingView,
      ]),
    subMenus: [
      MenuItem.fromOpts({
        name: containerTrackingMenu.list,
        url: "/containers/list",
        view: () =>
          import(
            /* webpackChunkName: "containers" */ "@/components/pages/containers/ListContainers.vue"
          ),
      }),
      MenuItem.fromOpts({
        name: containerTrackingMenu.v6List,
        url: "/containers/v6list",
        view: () =>
          import(
            /* webpackChunkName: "migrate" */ "@/components/pages/containers/ListV6Containers.vue"
          ),
        requiredFeatureFlag: EnumFeatureFlag.v6ContainerMigrator,
      }),
      MenuItem.fromOpts({
        name: containerTrackingMenu.kegstarList,
        url: "/containers/kegstar",
        view: () =>
          import(
            /* webpackChunkName: "migrate" */ "@/components/pages/containers/ListKegstarContainers"
          ),
        visible: tenantStore.state.kegstarSettings.isEnabled,
      }),
      MenuItem.fromOpts({
        name: containerTrackingMenu.create,
        url: "/containers/create",
        breadcrumbParentName: containerTrackingMenu.list,
        view: () =>
          import(
            /* webpackChunkName: "containers" */ "@/components/pages/containers/CreateContainers.vue"
          ),
        visible: false,
      }),
      MenuItem.fromOpts({
        name: containerTrackingMenu.v6Create,
        url: "/containers/migrate",
        breadcrumbParentName: containerTrackingMenu.v6List,
        view: () =>
          import(
            /* webpackChunkName: "migrate" */ "@/components/pages/containers/MigrateContainers.vue"
          ),
        visible: false,
        requiredFeatureFlag: EnumFeatureFlag.v6ContainerMigrator,
      }),
      MenuItem.fromOpts({
        name: containerTrackingMenu.containerTreatmentReport,
        url: "/containers/container-treatment-report",
        view: () =>
          import(
            /* webpackChunkName: "containers" */ "@/components/pages/containers/ContainerTreatmentReport.vue"
          ),
      }),
      MenuItem.fromOpts({
        name: containerTrackingMenu.view,
        url: "/containers/:id",
        breadcrumbParentName: containerTrackingMenu.list,
        view: () =>
          import(
            /* webpackChunkName: "containers" */ "@/components/pages/containers/EditContainer.vue"
          ),
        visible: false,
      }),
    ],
  }),
];
